export const querystring2json = (value: string): any =>
  JSON.parse(
    '{"' +
      decodeURI(value)
        .replace(/"/g, '\\"')
        .replace(/&/g, '","')
        .replace(/=/g, '":"') +
      '"}'
  );
